import { z } from 'zod';

import { Currency } from '../enums.js';

import { Ulid } from './common.js';

export const Lead = z.object({
  id: Ulid,
  projectId: Ulid,
  flowchartId: Ulid,
  currentStageId: Ulid,
  title: z.string().min(1).max(200),
  contactName: z.string().max(200).nullable(),
  contactEmail: z.string().email().nullable(),
  contactPhone: z.string().max(50).nullable(),
  company: z.string().max(200).nullable(),
  valueCents: z.number().int().nonnegative().nullable(),
  currency: Currency.nullable(),
  source: z.string().max(120).nullable(),
  customFields: z.record(z.unknown()),
  observations: z.string().default(''),
  assignedToUserId: Ulid.nullable(),
  createdByUserId: Ulid,
  enteredStageAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  archivedAt: z.string().datetime().nullable(),
});
export type Lead = z.infer<typeof Lead>;

export const LeadCreate = z.object({
  title: z.string().min(1).max(200),
  contactName: z.string().max(200).optional(),
  contactEmail: z.string().email().optional(),
  contactPhone: z.string().max(50).optional(),
  company: z.string().max(200).optional(),
  valueCents: z.number().int().nonnegative().optional(),
  currency: Currency.optional(),
  source: z.string().max(120).optional(),
  customFields: z.record(z.unknown()).optional().default({}),
  observations: z.string().max(20_000).optional(),
  assignedToUserId: Ulid.optional(),
});
export type LeadCreate = z.infer<typeof LeadCreate>;

export const LeadUpdate = LeadCreate.partial();
export type LeadUpdate = z.infer<typeof LeadUpdate>;

export const LeadMoveRequest = z.object({
  transitionId: Ulid,
  note: z.string().max(2000).optional(),
});
export type LeadMoveRequest = z.infer<typeof LeadMoveRequest>;

export const LeadAssignRequest = z.object({
  userId: Ulid.nullable(),
});
export type LeadAssignRequest = z.infer<typeof LeadAssignRequest>;

export const LeadStageHistoryEntry = z.object({
  id: Ulid,
  leadId: Ulid,
  fromStageId: Ulid.nullable(),
  toStageId: Ulid,
  transitionId: Ulid.nullable(),
  movedByUserId: Ulid,
  note: z.string().nullable(),
  durationSecondsInPrevious: z.number().int().nonnegative().nullable(),
  movedAt: z.string().datetime(),
});
export type LeadStageHistoryEntry = z.infer<typeof LeadStageHistoryEntry>;
